import { render } from "./PackageStep.vue?vue&type=template&id=c35f45a0&ts=true"
import script from "./PackageStep.vue?vue&type=script&lang=ts"
export * from "./PackageStep.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__